module.exports = __webpack_public_path__ + "static/media/crane-4.aac53ad7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/SwiftBankingResources/crane-4.svg
// module id = 218
// module chunks = 0